export default __webpack_public_path__ + "static/media/raffle.d0a29491.png";